import React, { FunctionComponent, useMemo, useState } from 'react'
import { BadQuestions } from '../masters/questions/BadQuestions'
import { TreeImagesVerification } from '../../image_verification/TreeImagesVerification'
import { StandardsInfo } from '../StandardsInfo'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { NodeListType } from './NodeListType'
import { DuplicatePointsCleanup } from '../treeManipulation/preDefinedFilters/DuplicatePointsCleanup'
import { BrokenLinksVerification } from './BrokenLinksVerification'

const verificationTools: {
  title: string
  Component: FunctionComponent<{ treeId: string; versionId: string }>
}[] = [
  { title: 'Node List Type', Component: NodeListType },
  { title: 'Questions Verification', Component: BadQuestions },
  { title: 'Image Verification', Component: TreeImagesVerification },
  { title: 'Standards Verification', Component: StandardsInfo },
  { title: 'Duplicate Points Leaves', Component: DuplicatePointsCleanup },
  { title: 'Broken Links', Component: BrokenLinksVerification },
]

export function TreeVerifications(p: { treeId: string; versionId: string }) {
  const [currentSelected, setCurrentSelected] = useState('')
  const tools = useTreeTools(p)

  const currentComponent =
    tools.find(({ title }) => title === currentSelected)?.component() ?? null

  return (
    <Box>
      <Box paddingBottom="15px">
        <FormControl>
          <InputLabel>Select Verification Tool</InputLabel>
          <Select
            value={currentSelected}
            label={'Select Verification Tool'}
            onChange={(e) => setCurrentSelected(e.target.value as string)}
            sx={{
              width: 'auto',
              minWidth: '220px',
            }}
          >
            {tools.map(({ title }) => (
              <MenuItem key={title} value={title}>
                {title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box>{currentComponent}</Box>
    </Box>
  )
}

function useTreeTools({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  return useMemo(() => {
    return verificationTools.map(({ title, Component }) => {
      return {
        title,
        component: () => (
          <Component key={title} treeId={treeId} versionId={versionId} />
        ),
      }
    })
  }, [treeId, versionId])
}
